export function getUserLang(): string[] {
  const data = localStorage.getItem("builderall-appshell--resources");
  let userData: any = {};

  try {
    if (data) {
      userData = JSON.parse(data);
    }
  } catch (e) {
    console.error("Erro ao fazer parse do localStorage:", e);
  }

  const lang = userData?.user?.lang || 'us_US';
  const [lang1 = 'us', lang2 = 'us'] = lang.toLowerCase().split('_');

  return [lang1, lang2, officeLang(lang1)];
}

export function officeLang(ref: string = 'en'): string {
  const langMap: { [key: string]: string } = {
    en: 'us',
    pt: 'br',
    de: 'de',
    it: 'it',
    es: 'es',
    fr: 'fr'
  };

  return langMap[ref.toLowerCase()] || 'us';
}
